import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "drv-form-root drv-verizon-account-name" }
const _hoisted_2 = { class: "drv-text-body-md drv-text-weight-medium" }
const _hoisted_3 = ["innerHTML"]

import HelpLink from "../HelpLink.vue";
import { computed, ref } from "vue";
import {
  ETelematicsMessagesKeys,
  IPlatform,
  IVerizonAccountName,
  EAuthTypes,
  ECommonMessages,
} from "../../../../types";
import { Input } from "draivn-ui-kit/components/input";
import {
  maxLengthValidator,
  minLengthValidator,
  requiredValidator,
} from "draivn-ui-domain";


export default /*@__PURE__*/_defineComponent({
  __name: 'VerizonAccountName',
  props: {
    modelValue: {},
    platform: {},
    disable: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props;

const icon = {
  name: "circle-information",
  size: 16,
};

const emit =
  __emit;

const EMPTY_MODEL = {
  type: EAuthTypes.ACCOUNT,
  agree: false,
  account_number: "",
};

const model = computed<IVerizonAccountName>({
  get() {
    return props.modelValue ?? EMPTY_MODEL;
  },
  set(value: IVerizonAccountName) {
    emit("update:modelValue", value);
  },
});

const agreeModel = computed<boolean>({
  get() {
    return props.modelValue?.agree ?? EMPTY_MODEL.agree;
  },
  set(value: boolean) {
    model.value = { ...model.value, agree: value };
  },
});

const accountNumberModel = computed<string>({
  get() {
    return props.modelValue?.account_number ?? EMPTY_MODEL.account_number;
  },
  set(value: string) {
    model.value = { ...model.value, account_number: value };
  },
});

const numberControl = ref<typeof Input | null>(null);
const hasError = computed<boolean>(() => {
  return (
    !accountNumberModel.value ||
    numberControl.value?.hasError ||
    !agreeModel.value
  );
});

__expose({
  hasError,
});

return (_ctx: any,_cache: any) => {
  const _component_d_checkbox = _resolveComponent("d-checkbox")!
  const _component_d_icon_tooltip = _resolveComponent("d-icon-tooltip")!
  const _component_d_input = _resolveComponent("d-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t(_unref(ETelematicsMessagesKeys).VERIZON_ACCOUNT_NAME_INSTRUCTION_1_TITLE)), 1),
      _createVNode(HelpLink, {
        link: _ctx.$t(_unref(ETelematicsMessagesKeys).VERIZON_INSTRUCTIONS_URL)
      }, null, 8, ["link"])
    ]),
    _createVNode(_component_d_checkbox, {
      class: "drv-embeded-checkbox drv-form-control-adaptive",
      modelValue: agreeModel.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((agreeModel).value = $event)),
      disable: _ctx.disable,
      label: 
        _ctx.$t(
          _unref(ETelematicsMessagesKeys).VERIZON_ACCOUNT_NAME_INSTRUCTION_CONFIRMATION_TITLE
        )
      
    }, null, 8, ["modelValue", "disable", "label"]),
    _createVNode(_component_d_input, {
      ref_key: "numberControl",
      ref: numberControl,
      class: "drv-my-2 drv-form-control-adaptive",
      modelValue: accountNumberModel.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((accountNumberModel).value = $event)),
      disable: _ctx.disable,
      "lazy-rules": "",
      "label-slot": "",
      rules: [
        _unref(requiredValidator)(_ctx.$t(_unref(ECommonMessages).REQUIRED_ERROR)),
        _unref(maxLengthValidator)(
          100,
          _ctx.$t(_unref(ECommonMessages).MAX_LENGTH_ERROR, { length: 100 })
        ),
        _unref(minLengthValidator)(
          2,
          _ctx.$t(_unref(ECommonMessages).MIN_LENGTH_ERROR, { length: 2 })
        ),
      ]
    }, {
      label: _withCtx(() => [
        _createElementVNode("span", null, _toDisplayString(_ctx.$t(_unref(ETelematicsMessagesKeys).BASE_ACCOUNT_NAME_INSTRUCTION_2_TITLE, {
            fieldName: _ctx.$t(_unref(ETelematicsMessagesKeys).VERIZON_ACCOUNT_NAME_TITLE),
          })), 1),
        _createVNode(_component_d_icon_tooltip, {
          icon: icon,
          class: "info-icon drv-color-n600 drv-mx-1",
          "tooltip-anchor": "top end",
          "tooltip-self": "top start"
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", {
              innerHTML: _ctx.$t(_unref(ETelematicsMessagesKeys).VERIZON_ACCOUNT_NAME_HINT)
            }, null, 8, _hoisted_3)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue", "disable", "rules"])
  ]))
}
}

})